/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import Chart from "react-apexcharts";
import debug from "../../../util/constants/Debug";

export const parseBarChartConfig = (data, scope) => {
  let chartConfig = null;
  try {
    const chartConfigCheck = data.charts.find((chart) => chart.type === scope);
    const chartData = chartConfigCheck?.data;
    if (chartData != null && Array.isArray(chartData)) {
      chartConfig = chartConfigCheck;
    }
  } catch (e) {
    debug.warn("Failed to parse data: " + data + " for scope" + scope);
  } finally {
    return chartConfig;
  }
};

const BarChart = ({
  title,
  subtitle,
  type = "bar",
  data,
  nameKey = "name",
  dataKeys = [{ name: "Value", key: "value" }],
  dataColors,
  height="100%",
  width="w-100"
}) => {
  // chart data
  const categories = data.map((item) => item[nameKey]);
  const series = dataKeys.map((key) => ({ name: key.name, data: data.map((item) => item[key.key]) }));

  // chart configuration
  const barOptions = {
    stroke: {
      show: true,
      width: 4,
      colors: ["transparent"],
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "75%",
        borderRadius: 3,
      },
    },
    dataLabels: {
      enabled: false,
    },
  };

  const lineOptions = {
    dataLabels: {
      enabled: true,
    },
  };

  const options = {
    chart: {
      type: type,
      toolbar: {
        show: false,
      },
      stacked: false,
      animations: {
        enabled: true,
        speed: 800,
        animateGradually: {
            enabled: false,
        },
        dynamicAnimation: {
            enabled: true,
            speed: 250
        }
      }
    },
    title: {
      text: title,
      align: "center",
      style: {
        fontSize: "22px",
        fontWeight: "normal",
        fontFamily: "Rubik"
      }
    },
    legend: {
      show: true,
      position: "right",
      horizontalAlign: "left"
    },
    xaxis: {
      categories: categories
    },
    yaxis: {
      labels: {
        formatter: (val) => {
          const formatted = val.toFixed(0);
          return formatted !== "Infinity" ? formatted : "1";
        }
      }
    },
    colors: dataColors,
    responsive: [
      {
        breakpoint: 1024,
        options: {
          plotOptions: {
            bar: {
              columnWidth: "50%",
              borderRadius: 7,
            },
          },
        },
      },
    ],
    ...(type === "bar" && barOptions),
    ...(type === "line" && lineOptions)
  };

  return (
    <div className="force-fill-container">
      <Chart className={width} height={height} options={options} series={series} type={type} />
    </div>
  );
};

export default BarChart;

